import { createContext } from "react";

import AlertModal from "src/app/components/modal/AlertModal";
import { useModal } from "src/app/hooks/modal/useModal";
import { IModalContext } from "src/types/global";

const ModalContext = createContext<IModalContext | null>(null);

const ModalProvider: React.FC<React.ReactNode> = ({ children }) => {
  const { active, triggerError, triggerSuccess, content, close } = useModal();

  return (
    <ModalContext.Provider value={{ active, triggerError, triggerSuccess, content, close }}>
      <AlertModal />
      {children}
    </ModalContext.Provider>
  );
};
export { ModalContext, ModalProvider };
